import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import posthog from 'posthog-js';
import App from './App';

if ((import.meta as any).env.PROD) {
  posthog.init('phc_W5hhBccqpaI1sfUyqLKPqGxFYxvg2YPf29pwNr5jb51', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
  });
}

Sentry.init({
  dsn: "https://42cd376760ee8f9981f095e0658d8f6f@o4511106885877760.ingest.us.sentry.io/4511106889089024",
  environment: (import.meta as any).env.MODE,
  enabled: (import.meta as any).env.PROD,
  sendDefaultPii: false,
  tracesSampleRate: 1.0,
  profilesSampleRate: 1.0,
  ignoreErrors: [
    // Firebase Analytics config fetch fails when the API is not enabled for this project.
    // Not actionable from the frontend — suppressing to reduce noise.
    'analytics/config-fetch-failed',
    'Dynamic config fetch failed',
  ],
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: 40, textAlign: 'center', fontFamily: 'sans-serif' }}>
          <h2 style={{ color: '#e53e3e' }}>Có lỗi xảy ra</h2>
          <p style={{ color: '#666', marginBottom: 16 }}>{String(error)}</p>
          <button
            onClick={resetError}
            style={{ padding: '8px 20px', background: '#4299e1', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer' }}
          >
            Thử lại
          </button>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
